import axios from './axios';

export default {
  get: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/projects`, params);
    return data;
  },

  getMinResponse: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/projects/browse-projects`, params);
    return data;
  },

  getParentAndProjects: async query => {
    const params = { params: query };
    const { data } = await axios.get(
      `/projects/browse-projects-and-parent-projects`,
      params
    );
    return data;
  },

  getGroups: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/projects/${id}/project-groups`, params);
    return data;
  },

  getMembers: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/projects/${id}/members`, params);
    return data;
  },

  getDocuments: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/projects/${id}/documents`, params);
    return data;
  },

  getById: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/projects/${id}`, params);
    return data;
  },

  getKinds: async id => {
    const { data } = await axios.get(`/projects/${id}/kinds`);
    return data;
  },

  getRoles: async id => {
    const { data } = await axios.get(`/projects/${id}/composed-bys`);
    return data;
  },

  create: async body => {
    const { data } = await axios.post(`/projects`, body);
    return data;
  },

  update: async (id, body) => {
    const { data } = await axios.put(`/projects/${id}`, body);
    return data;
  },

  delete: async id => {
    const { data } = await axios.delete(`/projects/${id}`);
    return data;
  },

  updateLeader: async (id, profileId) => {
    const { data } = await axios.post(
      `/projects/${id}/leader?profileId=${profileId}`
    );
    return data;
  },

  getItineraries: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/projects/${id}/itineraries`, params);
    return data;
  },

  getNonImpersonatedMembers: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/projects/${id}/members/not-impersonated`,
      params
    );
    return data;
  },

  getDocumentCount: async id => {
    const { data } = await axios.get(`/projects/${id}/document-count`);
    return data;
  },

  getMemberCount: async id => {
    const { data } = await axios.get(`/projects/${id}/member-count`);
    return data;
  },

  getTabCounters: async id => {
    const { data } = await axios.get(`/projects/${id}/tab-counters`);
    return data;
  },

  removeMemberFromProject: async (projectId, profileId) => {
    const { data } = await axios.delete(
      `/projects/${projectId}/members/${profileId}`
    );
    return data;
  },

  updateProjectLabels: async (id, body) => {
    const { data } = await axios.put(`/projects/${id}/update-labels`, body);
    return data;
  },

  reassignMember: async (id, body) => {
    const { data } = await axios.put(`/projects/${id}/reassign-member`, body);
    return data;
  },

  getMemberOfNames: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/projects/${id}/memberOf-name/values`,
      params
    );
    return data;
  },

  getDocumentStatusCount: async (id, language, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/projects/${id}/count-documents-status?language=${language}`,
      params
    );
    return data;
  },

  getItineraryStatusCount: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/projects/${id}/count-itineraries-status`,
      params
    );
    return data;
  },

  getLatestMembers: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/projects/${id}/members/latest`, params);
    return data;
  }
};
